// Dependencies
import getClassNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import NavLink from '../../nav-link';
import Counter from '../../tc-ui/counter';

class ConnectionsWidget extends Component {
  filterResults = routeName => {
    let routeNameCopy = routeName;
    if (routeName === 'invitations') routeNameCopy = 'invites';
    this.props.sendRouteName(routeNameCopy);
  };

  render() {
    const { data, name, counterStyle } = this.props;
    const classes = getClassNames('nav-link', 'connections-widget-link', {
      'is-zero': data === 0,
    });
    return (
      <NavLink
        filterResults={this.filterResults}
        classes={classes}
        className={classes}
        {...this.props}
      >
        {name}
        <Counter data={data} style={counterStyle} />
      </NavLink>
    );
  }
}

ConnectionsWidget.propTypes = {
  sendRouteName: PropTypes.func,
  data: PropTypes.number,
  name: PropTypes.string,
  counterStyle: PropTypes.object,
};

export default ConnectionsWidget;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-left-nav/connections-widget-item.jsx